var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStepperDoneAlt = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1545 11.3296C21.9501 11.1444 21.6807 11.048 21.4053 11.0613C21.1299 11.0746 20.871 11.1966 20.6855 11.4006L14.3414 18.3866L11.2764 15.2706C11.0819 15.0796 10.8201 14.9726 10.5475 14.9727C10.2748 14.9728 10.0131 15.0799 9.81871 15.2711C9.62429 15.4622 9.51269 15.722 9.50797 15.9946C9.50325 16.2672 9.60578 16.5308 9.79346 16.7286L13.6305 20.6286C13.7271 20.727 13.8424 20.8052 13.9697 20.8586C14.0969 20.912 14.2335 20.9395 14.3714 20.9396H14.3915C14.5331 20.9368 14.6727 20.9051 14.8016 20.8464C14.9306 20.7878 15.0462 20.7035 15.1415 20.5986L22.2255 12.7986C22.4106 12.5942 22.5071 12.3248 22.4938 12.0494C22.4805 11.774 22.3584 11.5151 22.1545 11.3296Z",
    fill: "#222F88"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "#222F88",
    strokeWidth: 4
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStepperDoneAlt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stepper-done-alt.ee786a91.svg";
export { ForwardRef as ReactComponent };